<template>
<!--  <v-chip v-if="data && data.newWallet" class="rounded-lg" small @click="action(data, 'walletShow')">-->
  <v-chip v-if="data && data.newWallet" class="rounded-lg" small @click="$emit('showWallet', data)">
    <div v-if="data.newWallet.balance >= 0">
      {{ data.newWallet !== null ? persianNum(currency(Math.floor(data.newWallet.balance.toString()))) : 'ساخته نشده' }}
    </div>
    <div v-else>
      {{
        data.newWallet !== null ? persianNum(currency(Math.floor(data.newWallet.balance.$numberDecimal.toString()))) : 'ساخته نشده'
      }}
    </div>
  </v-chip>
</template>

<script>
export default {
  name: "showBalancesDialog",

  props: {
    data: Object,
    action: Function,
    meta: Object
  }
}
</script>

<style scoped>

</style>